// @flow

import styled, { css } from 'styled-components';
import type { Theme } from '../../../../types';
import { media } from '../../../../helpers';

export default styled<any, Theme>('button')`
  background: none;
  border-radius: ${props => props.theme.cart.saveButton.borderRadius};
  border: 1px solid ${props => props.theme.cart.saveButton.borderColor};
  box-sizing: border-box;
  color: ${props => props.theme.cart.saveButton.color};
  cursor: pointer;
  padding: 0.625rem;

  ${media.lg(css`
    padding: 0.5rem;
  `)}
`;
